import {compose} from 'redux';
import withCitiesAndStreets from 'common/components/hoc-helpers/withCitiesAndStreets';
import Form_1 from './Form_1-redux';

export default compose(
  withCitiesAndStreets
)(Form_1);
